import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../constant/queryKey';
import { goodsService } from 'shared/src/api/goodsService';
import { useGoodsSno } from '../hooks/useGoodsSno';
import { useFixedCouponSno } from '../hooks/useFixedCouponSno';

export const useGoodsDetail = () => {
  const goodsSno = useGoodsSno();
  const fixedCouponSno = useFixedCouponSno();
  return useQuery({
    queryKey: queryKey.goodsDetail(goodsSno, fixedCouponSno),
    queryFn: () => goodsService.getGoodsDetail(goodsSno, fixedCouponSno),
  });
};
